module.exports = __webpack_public_path__ + "img/摄图网_401521307_banner.d7ec5c53.png";